/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: h6WonSNfUsoV

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { RawTable } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawTable/Table"; // plasmic-import: 5ruLSjF2t4Sr/codeComponent
import TableThead from "../../TableThead"; // plasmic-import: sYX9BWa2o65b/component
import TableTr from "../../TableTr"; // plasmic-import: ClRepu2PwVaX/component
import TableTh from "../../TableTh"; // plasmic-import: RjYJ6AJe84Rc/component
import TableTbody from "../../TableTbody"; // plasmic-import: 8BlIXCfTLl3k/component
import TableTd from "../../TableTd"; // plasmic-import: yk0RhbxcMVQJ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicTable.module.css"; // plasmic-import: h6WonSNfUsoV/css

createPlasmicElementProxy;

export type PlasmicTable__VariantMembers = {};
export type PlasmicTable__VariantsArgs = {};
type VariantPropType = keyof PlasmicTable__VariantsArgs;
export const PlasmicTable__VariantProps = new Array<VariantPropType>();

export type PlasmicTable__ArgsType = {
  tableLayout?: string;
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicTable__ArgsType;
export const PlasmicTable__ArgProps = new Array<ArgPropType>(
  "tableLayout",
  "children"
);

export type PlasmicTable__OverridesType = {
  table?: Flex__<"div">;
  rawTable?: Flex__<typeof RawTable>;
};

export interface DefaultTableProps {
  tableLayout?: string;
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicTable__RenderFunc(props: {
  variants: PlasmicTable__VariantsArgs;
  args: PlasmicTable__ArgsType;
  overrides: PlasmicTable__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          tableLayout: "auto"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"table"}
      data-plasmic-override={overrides.table}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.table
      )}
    >
      <RawTable
        data-plasmic-name={"rawTable"}
        data-plasmic-override={overrides.rawTable}
        className={classNames("__wab_instance", sty.rawTable)}
        style={(() => {
          try {
            return { tableLayout: $props.tableLayout };
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <TableThead
                className={classNames("__wab_instance", sty.tableThead__vyONq)}
              >
                <TableTr
                  className={classNames("__wab_instance", sty.tableTr___08JVq)}
                >
                  <TableTh
                    className={classNames("__wab_instance", sty.tableTh__egg6U)}
                  >
                    {"Header"}
                  </TableTh>
                  <TableTh
                    className={classNames("__wab_instance", sty.tableTh__pYjac)}
                  />

                  <TableTh
                    className={classNames(
                      "__wab_instance",
                      sty.tableTh___9I6A5
                    )}
                  />

                  <TableTh
                    className={classNames("__wab_instance", sty.tableTh__srbkf)}
                  />
                </TableTr>
              </TableThead>
              <TableTbody
                className={classNames("__wab_instance", sty.tableTbody___9Sp9T)}
              />
            </React.Fragment>
          ),
          value: args.children
        })}
      </RawTable>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  table: ["table", "rawTable"],
  rawTable: ["rawTable"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  table: "div";
  rawTable: typeof RawTable;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTable__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTable__VariantsArgs;
    args?: PlasmicTable__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicTable__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTable__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTable__ArgProps,
          internalVariantPropNames: PlasmicTable__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTable__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "table") {
    func.displayName = "PlasmicTable";
  } else {
    func.displayName = `PlasmicTable.${nodeName}`;
  }
  return func;
}

export const PlasmicTable = Object.assign(
  // Top-level PlasmicTable renders the root element
  makeNodeComponent("table"),
  {
    // Helper components rendering sub-elements
    rawTable: makeNodeComponent("rawTable"),

    // Metadata about props expected for PlasmicTable
    internalVariantProps: PlasmicTable__VariantProps,
    internalArgProps: PlasmicTable__ArgProps
  }
);

export default PlasmicTable;
/* prettier-ignore-end */
